import { getCookie, setCookie, getHostFromUrl } from './util';
import { getCookieDomain } from './util/cookie';
class SessionService {
    constructor() {
        this.domain = getCookieDomain();
        this.subscribers = [];
    }
    getToken() {
        return getCookie('visitor_token');
    }
    setToken(token) {
        setCookie('visitor_token', token, 356 * 20, this.domain);
        if (this.subscribers.length) {
            this.subscribers.map((callback) => callback(token));
        }
    }
    onTokenUpdate(callback) {
        this.subscribers.push(callback);
    }
    getTokenPayload() {
        const token = this.getToken();
        if (!token) {
            return null;
        }
        let payload;
        try {
            payload = JSON.parse(window.atob(token.split('.')[1]));
        }
        catch (e) {
            console.error('TuringClient: Invalid token payload!');
            return null;
        }
        return payload;
    }
    getIdentity(baseApiUrl, productName) {
        const payload = this.getTokenPayload();
        if (!payload || !payload.identities) {
            return null;
        }
        const loggingServerHost = getHostFromUrl(baseApiUrl);
        if (!payload.identities[loggingServerHost]) {
            return null;
        }
        if (!payload.identities[loggingServerHost][productName]) {
            return null;
        }
        return payload.identities[loggingServerHost][productName];
    }
}
export const sessionService = new SessionService();
//# sourceMappingURL=SessionService.js.map